import * as React from 'react';
import Router from 'next/router';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Box } from '@binanceus/uikit-core';
import getConfig from 'next/config';

import { Flex, Button } from '@bijie/react-bnb';

import FlexBox from './FlexBox';
import withErrorHandler from '../utils/withErrorHandler';
import { formatNumber } from '../utils/number';
import gtmTrack from '../utils/gtmTrack';
import zIndexScale from '../utils/zIndexScale';
// import { Button } from '@binance/uikit';


let t = null;

const {
  publicRuntimeConfig: { assetPrefix },
} = getConfig();
const Title = styled.div`
  margin: 0 0 16px 0;
  line-height: 158%;
  font-size: 20px;
  color: #0b0e11;
  user-select: none;
  padding: 0 0 0 18px;
`;
const Divider = styled.div`
  width: 1px;
  height: 114px;
  background-color: #e6e8ea;
`;

const RecommendBox = styled.div`
  width: 100%;
  user-select: none;
  background: transparent;
  margin-bottom: 40px;

`;

const MarketsBox = styled(FlexBox)`
  width: 100%;
  height: 162px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  overflow-x: auto;
  background: #fff;
  box-shadow: inset 0px -1px 0px #e6e8ea;
  border-radius: 4px;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const MarketItem = styled.div`
  display: table;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  line-height: 100%;
  font-size: 12px;
  color: ${({ theme }) => theme.fontColor};
  z-index: 0;
`;

const MarketItemInner = styled.div`
  padding: 0 24px;
  display: table-cell;
  vertical-align: middle;
  position: relative;
  z-index: ${zIndexScale.HotMarkets};
  .icon-logo {
    padding: 3px;
    width: 24px;
    height: 24px;
    border: 1px solid #eaecef;
    border-radius: 50%;
    box-sizing: border-box;
  }

  @media screen and (max-width: 1200px) {
    &{
      padding: 0 18px;
    }
  }
  @media screen and (max-width: 768px) {
    &{
      padding: 0 12px;
    }
  }
`;

const HoverContainer = styled.div`

    img.mainImg {
      width: 266px;
      height: 50px;
      // @media screen and (max-width: 1200px) {
      //   &{
      //     width: 180px;
      //     height: 28px;
      //   }
      // }
    }
    .active-area {
      position: relative;
      .bnc-flex {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: end;
      }

      > div{
        visibility: hidden;
      }
    }



    &:hover {
      div {
        visibility: visible;
      }
      img.mainImg {
        visibility: hidden;
      }
    }

`;

const mapStateToProps = ({
  locale, localeData, tickers, fiatRate, currencyList, userPreferredCurrency, topMovesArray, isLoggedIn,
}) => ({
  i18n: localeData[locale],
  locale,
  tickers,
  fiatRate,
  currencyList,
  userPreferredCurrency,
  topMovesArray,
  isLoggedIn,
});

type Ticker = {
  s: string,
  ba: string,
  qa: string,
  c: number,
  o: number,
  q: number,
  tickSize: number,
};

type Tickers = { [string]: Ticker };

type Props = {
  i18n: Object,
  locale: string,
  tickers: Tickers,
  userPreferredCurrency: Object,
  fiatRate: Object,
  currencyList: Array<Object>,
};

export default
@withErrorHandler
@connect(mapStateToProps)
class HotMarkets extends React.Component<Props> {
  prevTickers = {};

  constructor(props) {
    super(props);
    this.prevTickers = this.props.tickers;
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.tickers !== this.props.tickers ||
    (nextProps.isLoggedIn !== this.props.isLoggedIn);
  }

  getColor = (c, p) => {
    if (!p) {
      return '';
    }
    if (c > p) {
      return '#02C076';
    }
    if (c < p) {
      return '#D9304E';
    }
    return '';
  };

  getColor2 = (p) => {
    if (p > 0) {
      return '#02C076';
    }
    if (p < 0) {
      return '#D9304E';
    }
    return '';
  };

  getPercentage = (c, o) => {
    let percentage;
    if (o === 0) {
      percentage = '0%';
    } else {
      percentage = `${formatNumber(((c - o) / o) * 100, 2, '', true)}%`;
    }
    return {
      color: this.getColor(c, o),
      percentage,
    };
  };

  getMarketsArr = (data) => {
    // eslint-disable-next-line react/prop-types
    const topMovesArray2 = [...data];

    const tikersArr = topMovesArray2
      ?.sort((a, b) => a.sequence - b.sequence)
      ?.map((item) => {
        const obj = {
          enableOcbs: item.enableOcbs,
          enableTrading: item.enableTrading,
          assetCode: item.assetCode,
          key: `${item.assetCode}USD`,
          sequence: item.sequence,
          logoUrl: item.logoUrl,
          svgUrl: item.svgUrl,
          closePrice: item.closePrice,
          percen: {
            color: this.getColor2(item.percentage),
            percentage: `${formatNumber(item.percentage, 2, '', true)}%`,
          },
        };
        return obj;
      });
    t = this.props.tickers;

    if (Array.isArray(tikersArr)) {
      tikersArr.forEach((item, index) => {
        if (t[item.key]) {
          const pt = { ...item, ...t[item.key] };
          pt.lastPrice = t[item.key]?.lastPrice || 0;
          pt.percentage = this.getPercentage(t[item.key]?.c || 0, t[item.key]?.o || 0);
          tikersArr[index] = { ...tikersArr[index], ...pt };
        }
      });
    }

    return [...tikersArr];
  };

  getMarketPair = ([newSymbol, ticker]) => {
    const baseAsset = ticker.ba;
    const quoteAsset = newSymbol.split(baseAsset)[1];
    return `${baseAsset}_${quoteAsset}`;
  };

  getTradePageLinkHref = ([newSymbol, ticker]) => {
    const newPair = this.getMarketPair([newSymbol, ticker]);
    return `/en/trade/${newPair}`;
  };

  goBuyCrypto = (assetCode) => {
    Router.push(`/en/buy-sell-crypto/${assetCode}`);
  }

  renderHoverContainer = (enableOcbs, assetCode) => (
    <>

      {enableOcbs && (
        <div style={{ width: '50%', marginRight: 16 }}>
          <Button
            className="btn-primary btn-block"
            style={{ padding: 6 }}
            block={true}
            onClick={() => {
              gtmTrack({ ecommerce: null });
              gtmTrack({
                event: 'productClick',
                eventCategory: 'mk_buy',
                eventAction: 'click',
                eventLabel: `us_market::list_click_${assetCode}/USD`,
                layout: 'markets',
                elementid: 'top_movers_markets',
                ecommerce: {
                  click: {
                    actionField: { list: 'mk_buy' },
                    products: [
                      {
                        name: `pair::${assetCode}/USD`,
                        id: `${assetCode}/USD`,
                        price: 0,
                        brand: 'markets',
                        category: 'markets',
                        variant: 'markets',
                        position: '',
                      },
                    ],
                  },
                },
              });
              this.goBuyCrypto(assetCode);
            }}
          >
            <img style={{ marginRight: 8 }} src={assetPrefix + require('../static/images/common/icon-market-buy.svg')} />
            Buy
          </Button>
        </div>
      )}
      <div style={{ width: '50%' }}>
        <Button
          className="btn-outline btn-block"
          style={{ padding: 6 }}
          block={true}
          onClick={() => {
            gtmTrack({ ecommerce: null });
            gtmTrack({
              event: 'productClick',
              eventCategory: 'mk_tradecard',
              eventAction: 'click',
              eventLabel: `us_market::list_click_${assetCode}/USD`,
              layout: 'markets',
              elementid: 'top_movers_markets',
              ecommerce: {
                click: {
                  actionField: { list: 'mk_tradecard' },
                  products: [
                    {
                      name: `pair::${assetCode}/USD`,
                      id: `${assetCode}/USD`,
                      price: 0,
                      brand: 'markets',
                      category: 'markets',
                      variant: 'markets',
                      position: '',
                    },
                  ],
                },
              },
            });
            Router.push(`/en/trade/pro/${assetCode}_USD`);
          }}
        >
          <img style={{ marginRight: 8 }} src={assetPrefix + require('../static/images/common/icon-market-trade.svg')} />
          Trade
        </Button>
      </div>

    </>
  );

  render() {
    // const { topMoversArr } = this.state
    const topMoversArr = this.getMarketsArr(this.props.topMovesArray);

    return (
      <>
        <Title>Top Movers</Title>

        <RecommendBox>
          <MarketsBox justify="space-between">
            {topMoversArr?.map(({
              enableOcbs, enableTrading, assetCode, logoUrl, svgUrl, percentage, lastPrice, percen, closePrice,
            }, index) => (
              <HoverContainer>
                <MarketItem key={`topMoversArr${index}`}>
                  <MarketItemInner>
                    <FlexBox direction="column">
                      <FlexBox justify="flex-start" align="center">
                        <img src={logoUrl} className="icon-logo" />
                        <div style={{ margin: '0 10px', fontSize: '16px' }}>
                          {assetCode || '-'}
                          <span style={{ color: '#76808E' }}>/USD</span>
                        </div>
                        <div style={{ color: percentage?.color || percen?.color }}>{percentage?.percentage || percen?.percentage}</div>
                      </FlexBox>
                      <Box sx={{ margin: '10px 0', fontSize: '16px' }}>{lastPrice ? `$${formatNumber(lastPrice, 2)}` : `$${formatNumber(closePrice, 2)}`}</Box>
                      <Box>

                        <div className="active-area">
                          <Flex justifyContent="center" align="center">

                            {this.renderHoverContainer(enableOcbs, assetCode)}
                          </Flex>

                          <img className="mainImg" width="260" src={svgUrl} alt="" />
                        </div>


                      </Box>
                    </FlexBox>
                  </MarketItemInner>
                  {index !== topMoversArr.length - 1 && <Divider />}
                </MarketItem>
              </HoverContainer>
            ))}
          </MarketsBox>
        </RecommendBox>
      </>
    );
  }
}
